import { useEffect } from "react";

function AuthSuccess() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token && window.opener) {
      window.opener.postMessage({ type: "google-auth-token", token }, window.origin);
      window.close();
    }
  }, []);
  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>
      <h2>Giriş tamamlanıyor...</h2>
    </div>
  );
}

export default AuthSuccess;
